// Helpers para setear título + meta tags (description + Open Graph + Twitter)
// por página en runtime. NOTA: esto actualiza el DOM en el cliente — sirve para
// el navegador del usuario, pero los crawlers de redes sociales que NO ejecutan
// JS solo verán los tags base del index.html. El preview social completo por
// ruta requiere prerender/SSR (planeado para el sistema legal v1.3).

const SITE = 'FluidSol';

function upsertMeta(attr: 'name' | 'property', key: string, content: string): void {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

export interface PageMeta {
  title: string;
  description: string;
  url: string;
}

export function applyPageMeta({ title, description, url }: PageMeta): void {
  const fullTitle = `${title} · ${SITE}`;
  document.title = fullTitle;

  upsertMeta('name', 'description', description);

  upsertMeta('property', 'og:title', fullTitle);
  upsertMeta('property', 'og:description', description);
  upsertMeta('property', 'og:url', url);
  upsertMeta('property', 'og:type', 'article');
  upsertMeta('property', 'og:site_name', SITE);

  upsertMeta('name', 'twitter:card', 'summary');
  upsertMeta('name', 'twitter:title', fullTitle);
  upsertMeta('name', 'twitter:description', description);
}
